<template>
    <div class="mapview-container cf" style="position: relative">
        <div class="mapview-sidebar">
            <div v-if="!isMobile()">
                <div class="scroll-area">
                    <div class="scroll-up">
                        <i class="fas fa-long-arrow-alt-up"></i>
                    </div>
                    <div class="scrollbar">
                        <div class="handle">
                            <div class="mousearea"></div>
                        </div>
                    </div>
                    <div class="scroll-down">
                        <i class="fas fa-long-arrow-alt-down"></i>
                    </div>
                    <div class="sidebar-listing" id="sidebar-listing" ref="sidebarListing">
                        <div class="single-sidebar-listing cf" v-for="store in stores" :id="`store_id_${store.id}`" v-bind:class="{ 'store-active': isActive === store.id}" @click="sidebarListingClicked(store)">
                            <div class="listing-rating">
                                <h3>{{store.store_name}}</h3>
                                <p class="rating-id">Google Rating</p>
                                <div class="star-ratings-css">
                                    <div class="star-ratings-css-top" v-bind:style="{width: (store.google_rating * 100)/5 + '%'}"><span>★</span><span>★</span><span>★</span><span>★</span><span>★</span></div>
                                    <div class="star-ratings-css-bottom"><span>★</span><span>★</span><span>★</span><span>★</span><span>★</span></div>
                                </div>
                            </div>
                            <div class="hours-today"><span>{{ getTodayHours(store.store_hours) }}</span></div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="listings-carousel">
                    <carousel :perPageCustom="[[0, 1], [600, 2]]" :paginationEnabled="false" :navigationEnabled="true" navigation-next-label='<i class="fas fa-chevron-circle-right"></i>' navigation-prev-label="<i class='fas fa-chevron-circle-left'></i>">
                        <slide data-index="0" data-name="MySlideName" v-for="store in stores" v-bind:data="store" v-bind:key="store.id" :id="`store_id_${store.id}`" >
                            <div class="single-sidebar-listing cf" @click="sidebarListingClicked(store)">
                                <div class="listing-rating">
                                    <h3>{{store.store_name}}</h3>
                                    <p class="rating-id">Google Rating</p>
                                    <div class="star-ratings-css">
                                        <div class="star-ratings-css-top" v-bind:style="{width: (store.google_rating * 100)/5 + '%'}"><span>★</span><span>★</span><span>★</span><span>★</span><span>★</span></div>
                                        <div class="star-ratings-css-bottom"><span>★</span><span>★</span><span>★</span><span>★</span><span>★</span></div>
                                    </div>
                                </div>
                            </div>
                        </slide>
                    </carousel>
                </div>
            </div>
        </div>
        <div class="mapview-map-area cf">
            <div id="mapview-map" class="mapview-map">

            </div>
        </div>
        <div class="map-ad">
            <div class="map-ad-pic">
                <img :src="'../../img/dummy-ad.jpg'" />
            </div>
            <div class="map-ad-title">
                <h3>Dummy Ad</h3>
            </div>
            <div class="map-ad-applicable">
                Storewide
            </div>
            <div class="map-store-name">
                Weed Store
            </div>
        </div>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';
    export default {
        components: {
            Carousel,
            Slide
        },

        props: ['locations', 'initialStores'],

        data: function() {
            return {
                isActive: undefined,
                storemap: '',
                markers: '',
                marker: [],
                citySelected: false,
                stores: [],
                markerArray: [],
                zoomCoords: {},
                sideHeight: '',
                mapSlyelement: '',
                tiles: '',
                latlng: '',
                dates: new Date(),
                dayText: '',
                winWidth: $(window).width(),
                owlOptions: {
                    margin:10,
                    nav:true,
                    responsive:{
                        0:{
                            items:1
                        },
                        600:{
                            items:3
                        },
                        1000:{
                            items:5
                        }
                    }
                },
                owl: ''
            }

        },
        created: function(){
            this.stores = this.initialStores;
            console.log(this.stores);
            document.addEventListener("resize", this.getWindowWidth);

        },
        destroyed() {
            document.removeEventListener("resize", this.getWindowWidth);
        },
        mounted() {
            let _this = this;
            //console.log(this.stores)
            this.loadMap();
            //$('.sidebar-listing').height($('.sidebar-listing').outerHeight());
            //this.initSidebar();
            window.onresize = () => {
                this.getWindowWidth();
            }

        },
        computed: {
        },

        methods: {
            getWindowWidth(e) {
                this.winWidth = document.documentElement.clientWidth;
            },
            loadMap() {
                this.tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    maxZoom: 18,
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Points &copy 2012 LINZ'
                });
                this.latlng = L.latLng(-37.89, 175.46);

                this.storemap = L.map('mapview-map', {center: this.latlng, zoom: 13, layers: [this.tiles]});

                this.loadMarkers();
                var bounds = L.latLngBounds(this.markerArray);
                this.storemap.fitBounds(bounds);

                this.storemap.on('zoomend moveend', this.getZoomStores);
            },
            loadMarkers() {
                this.markers = L.markerClusterGroup({ chunkedLoading: true });
                for (var i = 0; i < Object.keys(this.stores).length; i++) {

                    this.marker[this.stores[i].id] = L.marker(L.latLng(this.stores[i].lat, this.stores[i].lng), { store_id: this.stores[i].id });
                    this.marker[this.stores[i].id]
                        .bindPopup( '<a href="/'+this.stores[i].country_slug+'/'+this.stores[i].region_slug+'/'+this.stores[i].city_slug+'/'+this.stores[i].store_name_slug +'/'+this.stores[i].id+'" target="_blank">' + this.stores[i].store_name + '</a>' )
                        .on('click', this.markerClicked);
                    this.markers.addLayer(this.marker[this.stores[i].id]);
                    this.markerArray.push({lat: this.stores[i].lat, lng: this.stores[i].lng, id: this.stores[i].id});
                }
                this.storemap.addLayer(this.markers);
            },
            listingClicked(store_id, lat, lng) {
                this.storemap.flyTo([lat, lng]);
                this.isActive = store_id;
            },
            markerClicked(e) {
                this.listingClicked(e.target.options.store_id, e.latlng.lat, e.latlng.lng);
            },
            sidebarListingClicked(store) {
                this.marker[store.id].openPopup();
                this.listingClicked(store.id, store.lat, store.lng);
            },
            getZoomStores(bounds) {
                let _this = this;
                this.zoomCoords.neLat = bounds.target.getBounds()._northEast.lat;
                this.zoomCoords.neLng = bounds.target.getBounds()._northEast.lng;
                this.zoomCoords.swLat = bounds.target.getBounds()._southWest.lat;
                this.zoomCoords.swLng = bounds.target.getBounds()._southWest.lng;

                axios.post('/api/mapzoom/', {coords: this.zoomCoords})
                .then(response => {
                    this.stores = response.data;
                    this.loadMarkers();
                    //this.resizeAndReload();
                })
                .catch(error => {
                        console.log(error)
                });
            },
            initSidebar() {
                let _this = this;
                if (window.innerWidth >= 1030) {
                    _this.mapSlyelement = {
                        obj: {},
                        el: '.sidebar-listing',
                        options: {
                            speed: 300,
                            easing: 'swing',
                            activatePageOn: 'click',
                            mouseDragging: 1,
                            touchDragging: 1,
                            scrollBy: 30,
                            dragHandle: 1,
                            dynamicHandle: 1,
                            clickBar: 1,
                            scrollBar: $('.map-view-page .mapview-container .mapview-sidebar .scroll-area .scrollbar'),
                            forward: $('map-view-page .mapview-container .mapview-sidebar .scroll-area .scroll-down i'),
                            backward: $('.map-view-page .mapview-container .mapview-sidebar .scroll-area .scroll-up i')
                        }
                    };


                    $(function () {
                        _this.mapSlyelement.obj = new Sly($(_this.mapSlyelement.el), _this.mapSlyelement.options);
                        _this.mapSlyelement.obj.init();
                    });
                }
            },
            resizeAndReload() {
                this.sideHeight = this.$refs.sidebarListing.clientHeight;

                if (this.winWidth > 768) {
                    console.log('gtrater');
                    $('.sidebar-listing').height(this.sideHeight);
                }
                this.mapSlyelement.obj.reload();
                console.log('resizing');
            },
            pluck(array, key) {
                return array.map(function(obj) {
                    return obj[key];
                });
            },
            isMobile() {
                if(this.winWidth < 1030) {
                    return true
                } else {
                    return false
                }
            },
            getTodayHours (hours){
                switch(this.dates.getDay()) {
                    case 0:
                        this.dayText = 'Sunday';
                        break;
                    case 1:
                        this.dayText = 'Monday';
                        break;
                    case 2:
                        this.dayText = 'Tuesday';
                        break;
                    case 3:
                        this.dayText = 'Wednesday';
                        break;
                    case 4:
                        this.dayText = 'Thursday';
                        break;
                    case 5:
                        this.dayText = 'Friday';
                        break;
                    case 6:
                        this.dayText = 'Saturday';
                        break;
                    default:
                    // code block
                }
                if (hours) {
                    if (typeof hours == 'string') {
                        hours = hours.split(',');
                    }
                    for (var i = 0; i < hours.length; i++) {
                        if (hours[i].includes(this.dayText)) {
                            var today_hours = hours[i].replace('["', '' );
                            return today_hours;
                        }
                    }
                }
            }
            
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/MapView.vue